/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { PotentialChangeOrdersControllerFindOneQueryResponse, PotentialChangeOrdersControllerFindOnePathParams, PotentialChangeOrdersControllerFindOneQueryParams, PotentialChangeOrdersControllerFindOne400, PotentialChangeOrdersControllerFindOne401, PotentialChangeOrdersControllerFindOne403, PotentialChangeOrdersControllerFindOne404 } from "../../models/changeOrdersController/PotentialChangeOrdersControllerFindOne";

function getPotentialChangeOrdersControllerFindOneUrl(id: PotentialChangeOrdersControllerFindOnePathParams["id"]) {
  const res = { method: 'GET', url: `/api/v1/potential-change-orders/${id}` as const }  
  return res
}

/**
 * @summary Get a potential change order by id
 * {@link /api/v1/potential-change-orders/:id}
 */
export async function potentialChangeOrdersControllerFindOne(id: PotentialChangeOrdersControllerFindOnePathParams["id"], params?: PotentialChangeOrdersControllerFindOneQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<PotentialChangeOrdersControllerFindOneQueryResponse, ResponseErrorConfig<PotentialChangeOrdersControllerFindOne400 | PotentialChangeOrdersControllerFindOne401 | PotentialChangeOrdersControllerFindOne403 | PotentialChangeOrdersControllerFindOne404>, unknown>({ method : "GET", url : getPotentialChangeOrdersControllerFindOneUrl(id).url.toString(), params, ... requestConfig })  
  return res.data
}